export default (id, src) => {
    const script = document.getElementById(id)
    return new Promise(resolve => {
        if(!script){
            const head = document.getElementsByTagName('head')[0]
            const dom = document.createElement('script')
            dom.id = id
            dom.src = src
            dom.async = true
            dom.defer = true
            dom.onload = () => {
                resolve()
            }
            head.appendChild(dom)
        }else{
            resolve()
        }
    })
}